"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commomCardHolderNames = void 0;
exports.commomCardHolderNames = ['master card',
    'nubank',
    'nubankgold',
    'willbank',
    'magazineluiza',
    'c6bank',
    'santanderfree',
    'magazineluiza',
    'credicardzero',
    'bradescoelo',
    'ourocardvisa',
    'mastercard',
    'ourocard',
    'santandersx',
    'meucartão',
    'visaplatinum',
    'hipercard',
    'bancopan',
    'nubankgold',
    'elomais',
    'nubankplatinum',
    'itaucard',
    'visagold'];
//# sourceMappingURL=commomCardHolderNames.js.map